import React from 'react';
import { User } from 'lucide-react';
import { TabType } from './types';

interface ProfileSidebarProps {
    user: any;
    tabs: TabType[];
    activeTab: string;
    onTabChange: (id: string) => void;
}

const ProfileSidebar: React.FC<ProfileSidebarProps> = ({ user, tabs, activeTab, onTabChange }) => {
    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="text-center mb-6">
                <div className="mx-auto h-20 w-20 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                    <User className="h-10 w-10 text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900">
                    {user?.first_name} {user?.last_name}
                </h3>
                <p className="text-sm text-gray-600">{user?.email}</p>
            </div>

            <nav className="space-y-2">
                {tabs.map((tab) => {
                    const IconComponent = tab.icon;
                    const isActive = activeTab === tab.id;

                    // Dynamic color classes are tricky with purgecss/tailwind if not literal
                    // But here we use standard colors from the Profile.tsx original code logic
                    const colorClasses: Record<string, string> = {
                        blue: isActive ? 'bg-blue-50 text-blue-700 border-blue-200' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50',
                        green: isActive ? 'bg-green-50 text-green-700 border-green-200' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50',
                        red: isActive ? 'bg-red-50 text-red-700 border-red-200' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50',
                        purple: isActive ? 'bg-purple-50 text-purple-700 border-purple-200' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                    };

                    return (
                        <button
                            key={tab.id}
                            onClick={() => onTabChange(tab.id)}
                            className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors border border-transparent ${colorClasses[tab.color] || ''}`}
                        >
                            <IconComponent className="h-4 w-4 mr-3" />
                            {tab.name}
                        </button>
                    );
                })}
            </nav>
        </div>
    );
};

export default ProfileSidebar;
